import logo from './logo.svg'

export const theme = {
    color: {
      primary: "#005ca9",
      primaryHover: "#005298",
    },
    logoImage: logo,
    backend: "https://blasmusikinbayern.de/",
    directory: "/kiosk",
    header: {
      customer: "",
      title: "Bayerischer Blasmusikverband",
      lineHeader: true,
    },
    info: [
      {
      text: 'Impressum',
      link: 'https://bbmv-online.de/impressum#c'
    },
      {
      text: 'Datenschutz',
      link: 'https://bbmv-online.de/impressum#datenschutz'
    }
  ]
  };